// @flow
import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { handleSubmit } from './handleSubmit';
import Wallet from './Wallet';
import { WalletsContainerDiv } from './CryptoWalletsStyles';
import SaveOverlay from '../../../components/SaveOverlay';
import Header from './Header';
import { type Currency } from '../../../utilities/types';
import confirmDiscardForm from '../../../components/ConfirmDiscardForm';

type Props = {
  handleSubmit: () => void,
  pristine: boolean,
  submitting: boolean,
  submitSucceeded: boolean,
  error: ?string,
  cryptoCurrencies: Currency[],
  sidebarOpened: boolean,
  sidebarOpenedDevice: boolean,
  viewportDevice: boolean
};

class CryptoWalletsForm extends Component<Props> {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <SaveOverlay
          pristine={this.props.pristine}
          submitting={this.props.submitting}
          submitSucceeded={this.props.submitSucceeded}
          error={this.props.error}
          sidebarOpened={this.props.sidebarOpened}
          sidebarOpenedDevice={this.props.sidebarOpenedDevice}
          viewportDevice={this.props.viewportDevice}
        />
        <Header
          pristine={this.props.pristine}
          submitting={this.props.submitting}
          submitSucceeded={this.props.submitSucceeded}
          error={this.props.error}
        />
        <WalletsContainerDiv>
          {this.props.cryptoCurrencies.map(currency => (
            <Wallet key={currency.id} currency={currency} />
          ))}
        </WalletsContainerDiv>
      </form>
    );
  }
}

export default reduxForm({
  form: 'cryptoWalletsForm',
  onSubmit: handleSubmit,
  enableReinitialize: true
  // $FlowFixMe
})(confirmDiscardForm(CryptoWalletsForm));
